import { useSelector } from 'react-redux';
import ResourceLibrary from '../../../../components/resourceLibrary';
import { useAppDispatch } from '../../../../store';
import { File, Machine, UploadBusinessType } from '../../../../types';
import { selectMachine, setMachine } from '../../../../slices/machines';
import { updateMachine } from '../../../../utils/httpRequest';

const MachineResourceLibrary = () => {
  const dispatch = useAppDispatch();
  const machine = useSelector(selectMachine);

  const handleUpdateDocuments = async (documents: File[]) => {
    const res = await updateMachine({
      ...machine,
      documents,
    } as Machine);

    dispatch(setMachine(res.data));
  };

  return (
    <ResourceLibrary
      documents={machine?.documents}
      templateID={machine?.templateID}
      uploadBusinessType={UploadBusinessType.MACHINE}
      onUpdateDocuments={handleUpdateDocuments}
    />
  );
};

export default MachineResourceLibrary;
